import { render } from "./GeneratePresentation.vue?vue&type=template&id=3cde40aa"
import script from "./GeneratePresentation.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneratePresentation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Insights/GeneratePresentation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cde40aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cde40aa', __exports__)) {
    api.reload('3cde40aa', __exports__)
  }
  
  module.hot.accept("./GeneratePresentation.vue?vue&type=template&id=3cde40aa", () => {
    api.rerender('3cde40aa', render)
  })

}


export default __exports__